/** Narrower than `HTMLElement`, so it is testable without a DOM, which the vitest projects lack. */
export interface ConsentNode {
	hasAttribute(name: string): boolean;
	querySelector(selectors: string): unknown;
	innerHTML: string;
}

/** On the placeholder that renders while content has not arrived. */
export const CONSENT_PENDING_ATTRIBUTE = 'data-consent-pending';

/**
 * The text the person had in front of them when they ticked the box. `undefined` while it is still a
 * placeholder, so callers keep what they stored instead of recording skeletons as the contract.
 */
export function readAcceptedHtml(node: ConsentNode | null | undefined): string | undefined {
	if (!node) return undefined;
	if (node.hasAttribute(CONSENT_PENDING_ATTRIBUTE)) return undefined;
	if (node.querySelector(`[${CONSENT_PENDING_ATTRIBUTE}]`) !== null) return undefined;

	const html = node.innerHTML.trim();
	return html === '' ? undefined : html;
}
